import {notEmpty} from '@wandb/weave/common/util/obj';
import {useMemo} from 'react';

import {useRunSelectorQuery} from '../../../state/graphql/runSelectorQuery';
import * as RunHelpers2 from '../../../util/runhelpers';
import * as Run from '../../../util/runs';
import * as TableCols from '../../../util/tablecols';

export const useFilteredKeys = (
  runSelectorQuery: ReturnType<typeof useRunSelectorQuery>
) => {
  const projectFields = runSelectorQuery.initialLoading
    ? undefined
    : runSelectorQuery.project?.fields.edges;
  return useMemo(() => {
    if (!projectFields) {
      return [];
    }
    const paths = projectFields.map(edge => edge.node.path);
    const suggested = RunHelpers2.keySuggestions(paths);
    return TableCols.filterLegacyKeys(
      suggested.map(Run.keyFromString).filter(notEmpty)
    );
  }, [projectFields]);
};
